import { render, staticRenderFns } from "./show-premium-modal.vue?vue&type=template&id=86fc7d88&scoped=true&"
import script from "./show-premium-modal.vue?vue&type=script&lang=js&"
export * from "./show-premium-modal.vue?vue&type=script&lang=js&"
import style0 from "./show-premium-modal.vue?vue&type=style&index=0&id=86fc7d88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fc7d88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86fc7d88')) {
      api.createRecord('86fc7d88', component.options)
    } else {
      api.reload('86fc7d88', component.options)
    }
    module.hot.accept("./show-premium-modal.vue?vue&type=template&id=86fc7d88&scoped=true&", function () {
      api.rerender('86fc7d88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/additions/calculation-by-period-modals/show-premium-modal.vue"
export default component.exports